import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {popupSetGlobalKey} from '../../actions/builderPopup.js';

class PopupPreview extends React.Component {
	constructor(props) {
		super(props);
		this.state = {

		}
		this.send = this.send.bind(this);
		this.incMessage = this.incMessage.bind(this);
	}


	componentDidMount() {
		this.updateIframe();
	}

	componentWillReceiveProps(next) {
		if(next.builderPopup.stage != this.props.builderPopup.stage) {
			this.editor().showStage(next.builderPopup.stage);
		}

		if(next.builderPopup.component.id) {
			let update = {};
			update.content = next.builderPopup.popup.content['@@'+next.builderPopup.component.id+'@@'];
			update.style = next.builderPopup.popup.style['#'+next.builderPopup.component.id];
			update.id = '#'+next.builderPopup.component.id;
			update.type = next.builderPopup.component.type;
			this.editor().updateElm(update);
		}

		let container = {};
		container.content = false;
		container.style = next.builderPopup.popup.style['#container-stage-'+next.builderPopup.stage];
		container.id = '#container-stage-'+next.builderPopup.stage;
		container.type = 'crall-container';
		this.editor().updateElm(container);




	}

	componentDidUpdate(props,state) {
		if(this.props.builderPopup.popup.custom != props.builderPopup.popup.custom) {
			this.updateIframe();
		}
	}

	generateStyle() {
		let style = "";
		for(let selector in this.props.builderPopup.popup.style) {
			style += selector+" {\n";
			for(let key in this.props.builderPopup.popup.style[selector]) {
				style += key+":"+this.props.builderPopup.popup.style[selector][key]+";\n";
			}
			style += "}\n";
		}

		style += this.props.builderPopup.popup.custom;

		return style;
	}

	buildHtml() {
		let html = `
		${this.props.builderPopup.popup.header}
		${this.props.builderPopup.popup.template.style}
		${this.generateStyle()}
		.box-stage-1,.box-stage-2,.box-stage-3 {
			left: 0; 
			right: 0; 
			margin-left: auto; 
			margin-right: auto;
		}
		.editable:hover {
			box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
			border:1px solid #cccccc;
			cursor:pointer;
		}
		</style></head><body>
		${this.props.builderPopup.popup.template.body}
		${this.props.builderPopup.popup.footer}
		`;

		html = this.replaceContent(html);

		return html;
	}

	replaceContent(html) {
		for(let i in this.props.builderPopup.popup.content) {
			html = html.replace(i,this.props.builderPopup.popup.content[i]);
		}
		return html;
	}

	updateIframe() {
        this.bindEvents();
		this.refs.preview.contentWindow.document.open();
        this.refs.preview.contentWindow.document.write(this.buildHtml());
        this.refs.preview.contentWindow.document.close();
	}

	editor() {
		return this.refs.preview.contentWindow._crallEditor;
	}

	send(obj) {
		if(typeof this.refs.preview.contentWindow.postMessage == 'function') {
			this.refs.preview.contentWindow.postMessage(obj,"*");
		}
	}

	afterUpdate() {
		this.editor().showStage(this.props.builderPopup.stage);
		this.props.stageTypes(this.editor().getAllTypes());
	}

	bindEvents() {
		window.addEventListener("message", this.incMessage, false);
	}

	incMessage(event) {
		switch(event.data.action) {
			case 'clicked':
				this.props.popupSetGlobalKey('component',event.data.payload);
			break;

			case 'ready':
                this.afterUpdate();
			break;
		}
	}

    componentWillUnmount() {
        window.removeEventListener('message',
            this.incMessage,
            false
        );
	}
	

	render() {

		return (

			<div className="height-100">
				<iframe ref="preview" style={{width:'100%',height:'100%','border':0}} />
			 </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		builderPopup:state.builderPopup
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({popupSetGlobalKey},dispatch)
}

PopupPreview = connect(mapStateToProps,mapDispatchToProps)(PopupPreview);
export default PopupPreview;


// WEBPACK FOOTER //
// ./components/builder/PopupPreview.js